export const CountryCases = {
    "United States": [1092328, 63538, 128436],
    "Spain": [213435, 24543, 112050],
    "Italy": [205463, 27967, 75945],
    "United Kingdom": [171253, 26771, 35000],
    "Germany": [163009, 6623, 117734],
    "France": [129581, 24376, 49476],
    "Turkey": [120204, 3174, 48886],
    "Russia": [106498, 1073, 11619],
    "Iran": [94640, 6028, 75103],
    "Brazil": [85380, 5901, 35935],
    "China": [82874, 4633, 77642],
    "Canada": [53236, 3184, 21423],
    "Belgium": [48519, 7594, 11576],
    "Netherlands": [39316, 4795, 10000],
    "Peru": [36976, 1051, 10405],
    "India": [33610, 1075, 8373],
    "Switzerland": [29586, 1423, 23400],
    "Portugal": [25045, 989, 1519],
    "Ecuador": [24934, 900, 1806],
    "Saudi Arabia": [22753, 162, 3163],
    "Sweden": [21092, 2586, 1005],
    "Ireland": [20612, 1232, 13386],
    "Mexico": [17799, 1732, 2627],
    "Pakistan": [16817, 385, 4315],
    "Singapore": [16169, 15, 1188],
    "Chile": [16023, 227, 8580],
    "Israel": [15946, 222, 8561],
    "Austria": [15450, 584, 12907],
    "Japan": [14305, 455, 3466],
    "Belarus": [14027, 89, 2386],
    "Qatar": [13409, 10, 1372],
    "Poland": [12877, 644, 3236],
    "United Arab Emirates": [12481, 105, 2429],
    "Romania": [12240, 695, 4017],
    "South Korea": [10774, 248, 9072],
    "Ukraine": [10406, 261, 1238],
    "Indonesia": [10118, 792, 1522],
    "Denmark": [9158, 452, 6546],
    "Serbia": [9009, 179, 1343],
    "Philippines": [8488, 568, 1043],
    "Norway": [7759, 210, -1],
    "Bangladesh": [7667, 168, 160],
    "Czech Republic": [7682, 236, 3314],
    "Dominican Republic": [6972, 301, 1301],
    "Australia": [6762, 92, 5720],
    "Panama": [6532, 188, 576],
    "Colombia": [6211, 278, 1411],
    "Malaysia": [6002, 102, 4171],
    "South Africa": [5647, 103, 2073],
    "Egypt": [5537, 392, 1381],
    "Finland": [4995, 211, 3000],
    "Morocco": [4423, 170, 984],
    "Argentina": [4415, 218, 1299],
    "Kuwait": [4024, 26, 1539],
    "Algeria": [4006, 450, 1779],
    "Moldova": [3897, 119, 1182],
    "Luxembourg": [3784, 90, 3213],
    "Kazakhstan": [3402, 25, 866],
    "Bahrain": [3040, 8, 1500],
    "Thailand": [2954, 54, 2684],
    "Hungary": [2775, 312, 581],
    "Greece": [2591, 140, 1374],
    "Oman": [2348, 11, 495],
    "Afghanistan": [2171, 64, 260],
    "Iraq": [2085, 93, 1375],
    "Croatia": [2076, 69, 1348],
    "Ghana": [2076, 17, 212],
    "Armenia": [2066, 32, 929],
    "Uzbekistan": [2017, 9, 1096],
    "Nigeria": [1932, 58, 319],
    "Cameroon": [1832, 61, 934],
    "Azerbaijan": [1804, 24, 1325],
    "Iceland": [1797, 10, 1670],
    "Bosnia & Herzegovina": [1757, 69, 727],
    "Estonia": [1689, 52, 249],
    "Puerto Rico": [1539, 92, -1],
    "Bulgaria": [1506, 66, 266],
    "Cuba": [1501, 61, 681],
    "Guinea": [1495, 7, 329],
    "North Macedonia": [1465, 77, 738],
    "Slovenia": [1429, 91, 233],
    "Slovakia": [1396, 23, 524],
    "Lithuania": [1385, 45, 589],
    "Ivory Coast": [1275, 14, 574],
    "New Zealand": [1479, 19, 1252],
    "Bolivia": [1110, 59, 117],
    "Djibouti": [1089, 2, 642],
    "Charles de Gaulle": [1081, 0, 0],
    "Hong Kong": [1038, 4, 846],
    "Tunisia": [994, 41, 305],
    "USS Theodore Roosevelt": [969, 1, 29],
    "Senegal": [933, 9, 334],
    "Latvia": [858, 15, 348],
    "Cyprus": [850, 15, 148],
    "Kosovo": [799, 22, 249],
    "Albania": [773, 31, 470],
    "Honduras": [771, 71, 79],
    "Kyrgyzstan": [746, 8, 462],
    "Andorra": [745, 42, 468],
    "Lebanon": [725, 24, 150],
    "Costa Rica": [719, 6, 323],
    "Niger": [719, 32, 452],
    "Diamond Princess": [712, 13, 651],
    "Sri Lanka": [663, 7, 154],
    "Burkina Faso": [645, 43, 506],
    "Uruguay": [630, 15, 412],
    "Somalia": [601, 28, 31],
    "Guatemala": [585, 16, 65],
    "San Marino": [569, 41, 78],
    "Georgia": [539, 6, 184],
    "Palestine": [507, 2, 76],
    "DR Congo": [500, 31, 65],
    "Mali": [490, 26, 135],
    "Tanzania": [480, 16, 167],
    "Malta": [465, 4, 351],
    "Jordan": [453, 8, 362],
    "Sudan": [442, 31, 39],
    "Taiwan": [429, 6, 322],
    "Kenya": [396, 17, 144],
    "Jamaica": [396, 7, 29],
    "Maldives": [396, 1, 17],
    "El Salvador": [395, 9, 119],
    "Venezuela": [333, 10, 142],
    "Mauritius": [332, 10, 310],
    "Montenegro": [322, 7, 214],
    "Equatorial Guinea": [315, 1, 9],
    "Isle of Man": [315, 21, 260],
    "Jersey": [286, 23, 197],
    "Gabon": [276, 3, 67],
    "Vietnam": [270, 0, 222],
    "Guernsey": [251, 13, 202],
    "Paraguay": [249, 9, 111],
    "Rwanda": [243, 0, 104],
    "Congo": [220, 9, 19],
    "Guinea-Bissau": [205, 1, 19],
    "Faroe Islands": [187, 0, 184],
    "Myanmar": [150, 6, 27],
    "Costa Atlantica": [148, 0, 0],
    "Gibraltar": [144, 0, 131],
    "Liberia": [141, 16, 45],
    "Guam": [141, 5, 128],
    "Brunei": [138, 1, 124],
    "Ethiopia": [131, 3, 59],
    "Greg Mortimer": [128, 0, -1],
    "Madagascar": [128, 0, 92],
    "Sierra Leone": [124, 7, 21],
    "Cambodia": [122, 0, 119],
    "Cape Verde": [121, 1, 4],
    "Luhansk PR": [119, 1, 7],
    "Togo": [116, 9, 65],
    "Trinidad & Tobago": [116, 8, 72],
    "Bermuda": [111, 6, 48],
    "Northern Cyprus": [108, 3, 52],
    "Zambia": [106, 3, 55],
    "Aruba": [100, 2, 79],
    "Donetsk PR": [100, 3, 11],
    "Eswatini": [100, 1, 12],
    "Monaco": [95, 4, 64],
    "Uganda": [83, 0, 52],
    "Liechtenstein": [82, 1, 55],
    "Barbados": [81, 7, 39],
    "Haiti": [81, 8, 8],
    "Bahamas": [80, 11, 25],
    "Guyana": [78, 8, 18],
    "Mozambique": [76, 0, 9],
    "Sint Maarten": [76, 13, 44],
    "Cayman Islands": [73, 1, 10],
    "Chad": [73, 5, 33],
    "Benin": [64, 1, 33],
    "USS Kidd": [64, 0, 0],
    "Libya": [61, 3, 18],
    "French Polynesia": [57, 0, 43],
    "Nepal": [57, 0, 16],
    "U.S. Virgin Islands": [57, 4, 51],
    "Central African Republic": [50, 0, 10],
    "Macau": [45, 0, 35],
    "Syria": [43, 3, 21],
    "Zimbabwe": [40, 4, 5],
    "Eritrea": [39, 0, 19],
    "Mongolia": [38, 0, 9],
    "Malawi": [37, 3, 7],
    "South Sudan": [34, 0, 0],
    "Angola": [27, 2, 7],
    "East Timor": [24, 0, 2],
    "Antigua & Barbuda": [23, 3, 3],
    "Botswana": [23, 1, 5],
    "Grenada": [19, 0, 10],
    "Laos": [19, 0, 4],
    "Belize": [18, 2, 5],
    "Fiji": [18, 0, 12],
    "New Caledonia": [18, 0, 17],
    "Saint Lucia": [17, 0, 15],
    "Curaçao": [16, 1, 13],
    "Dominica": [16, 0, 13],
    "Namibia": [16, 0, 8],
    "Saint Vincent": [16, 0, 8],
    "São Tomé & Príncipe": [16, 1, 4],
    "Saint Kitts & Nevis": [15, 0, 6],
    "Tajikistan": [15, 0, 0],
    "Nicaragua": [14, 4, 7],
    "Northern Mariana Islands": [14, 2, 11],
    "Falkland Islands": [13, 0, 11],
    "MS Zaandam": [13, 4, -1],
    "Åland Islands": [12, 0, 0],
    "Coral Princess": [12, 2, -1],
    "The Gambia": [12, 1, 8],
    "Turks & Caicos Islands": [12, 1, 5],
    "Burundi": [11, 1, 4],
    "Greenland": [11, 0, 11],
    "Montserrat": [11, 1, 3],
    "Seychelles": [11, 0, 7],
    "Vatican City": [11, 0, 2],
    "Suriname": [10, 1, 8],
    "HNLMS Dolfijn": [8, 0, -1],
    "Mauritania": [8, 1, 6],
    "Papua New Guinea": [8, 0, 0],
    "Artsakh": [7, 0, 0],
    "Bhutan": [7, 0, 5],
    "British Virgin Islands": [6, 1, 3],
    "Somaliland": [6, 0, 1],
    "Yemen": [6, 2, 1],
    "Abkhazia": [3, 0, 2],
    "Anguilla": [3, 0, 3],
    "Bonaire": [2, 0, 2],
    "Saba": [2, 0, 0],
    "Sint Eustatius": [2, 0, 1],
    "Comoros": [1, 0, 0],
    "Guantanamo Bay": [1, -1, -1],
    "Saint Pierre & Miquelon": [1, 0, 0]
};